module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "author"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "id": "title"
    }
  }), _vm._v("JEAN-LUC NANCY")]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_vm._v("Dis-Enclosure")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('strong', [_c('em', [_vm._v("The Deconstruction of Christianity")])])]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('strong', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATED BY")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTINA")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERGO")]), _vm._v(", G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABRIEL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALENFANT, AND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHAEL")]), _vm._v(" B. S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MITH")])])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24473954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 69
// module chunks = 0